import React from 'react';
import { useAvailableDays } from '../hooks/use-available-days';
import { useFileSession } from '../contexts/FileSessionContext';
import { useDayNavigation } from '../contexts/DayNavigationContext';
import './DateSelector.css';
import { ArrowIcon } from './icons/ArrowIcon';

// no locale emits English month abbreviations
// with the trailing dot, so it's assembled manually. The dot is skipped
// when the month isn't actually abbreviated (May).
const formatDisplayDate = (ms: number) => {
  const date = new Date(ms);
  const short = date.toLocaleDateString('en-GB', { month: 'short' });
  const long = date.toLocaleDateString('en-GB', { month: 'long' });
  const month = short === long ? short : `${short}.`;
  return `${date.getDate()} ${month} ${date.getFullYear()}`;
};

export const DateSelector: React.FC = () => {
  const { parsedEdfInfo } = useFileSession();
  const { therapyTimeInterval, selectedDayMs, onSelectedDayChange } =
    useDayNavigation();

  const availableDays = useAvailableDays({
    parsedEdfInfo,
    therapyTimeInterval,
    selectedDayMs,
    onSelectedDayChange,
  });

  const currentDayIndex =
    selectedDayMs === null ? -1 : availableDays.indexOf(selectedDayMs);

  const prevDay = () => {
    if (currentDayIndex > 0) {
      onSelectedDayChange(availableDays[currentDayIndex - 1]);
    }
  };

  const nextDay = () => {
    if (currentDayIndex !== -1 && currentDayIndex < availableDays.length - 1) {
      onSelectedDayChange(availableDays[currentDayIndex + 1]);
    }
  };

  const isPrevDisabled = currentDayIndex <= 0;
  const isNextDisabled =
    currentDayIndex === -1 || currentDayIndex >= availableDays.length - 1;

  const displayLabel = selectedDayMs
    ? formatDisplayDate(selectedDayMs)
    : 'No data';

  return (
    <div className='topbar__navigation'>
      <button
        className='topbar__nav-btn'
        onClick={prevDay}
        disabled={isPrevDisabled}
      >
        <ArrowIcon size={20} />
      </button>

      <span className='topbar__date'>{displayLabel}</span>

      <button
        className='topbar__nav-btn'
        onClick={nextDay}
        disabled={isNextDisabled}
      >
        <ArrowIcon className='date-selector__next-btn' size={20} />
      </button>
    </div>
  );
};
